import templateUrl from 'webutils/address-validator-prompt.htm'
import AddressValidatorPromptController from 'webutils/address-validator-prompt.controller'
//import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'

const resolve = () => null;
const reject = reason => console.warn('reject reason', reason);

const AddressValidatorPrompt = {
	open(options) {
		return modals.open(Object.assign({
			size: 'lg address-validator-prompt',
			templateUrl,
			resolve: {
				options: () => options
			},
			bindToController: true,
			controller: AddressValidatorPromptController,
			controllerAs: '$ctrl'
		}, (options || {}).modal)).result;
	}
};

export default AddressValidatorPrompt;